<pt-mounting-material
  *ngIf="availableForMount$ | async as availableMaterials"
  [availableMountingMaterial]="availableMaterials.materials"
  [billOfMaterialArticleList]="availableMaterials.articles"
  (mountingMaterialSubmit)="onSelectClick($event)"
  [submitButtonLabel]="'PILE_TURNER.MACHINE_LOCATION_SUBMIT'"
  [loadingTopic]="LOADING_TOPIC"
></pt-mounting-material>
